var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_130)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 1.73242C5.02916 1.73242 1 4.917 1 8.8476C1 11.4051 2.70615 13.6466 5.26877 14.9007C5.08014 15.6025 4.58733 17.4463 4.48877 17.8406C4.36641 18.33 4.6672 18.3232 4.86602 18.1923C5.02066 18.0887 7.33178 16.5168 8.3293 15.8387C8.87139 15.9186 9.42877 15.9611 9.99976 15.9611C14.9704 15.9611 18.9995 12.7765 18.9995 8.8476C18.9995 4.9187 14.9704 1.73242 9.99976 1.73242Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72285 7.54696H4.649C4.649 7.54696 4.6541 10.0909 4.649 10.684C4.649 11.1173 5.61253 11.1224 5.61083 10.6908L5.61423 7.58095C5.61423 7.58095 5.92521 7.58265 6.53528 7.58265C7.11136 7.58265 7.11136 6.6769 6.53528 6.6769C5.88612 6.6769 3.71775 6.6582 3.71775 6.6582C3.17396 6.6582 3.17566 7.54696 3.71775 7.54696",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 4,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7231 7.55087H4.64924C4.64924 7.55087 4.65434 10.0948 4.64924 10.6879C4.64924 11.1212 5.61277 11.1263 5.61107 10.6947L5.61447 7.58486C5.61447 7.58486 5.92545 7.58656 6.53552 7.58656C7.1116 7.58656 7.1116 6.6808 6.53552 6.6808C5.88637 6.6808 3.718 6.66211 3.718 6.66211C3.17421 6.66211 3.17591 7.55087 3.718 7.55087",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11355 6.66211H3.17786V11.1263H7.11355V6.66211Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15558 7.70483L8.67049 9.31921H7.5965L8.15558 7.70483ZM7.5778 6.94862C7.35009 7.44992 6.52591 9.82052 6.25401 10.4493C6.05689 10.903 6.90826 11.2735 7.10539 10.8197L7.29061 10.1723H8.98487C8.98487 10.1723 8.92709 10.1995 9.1514 10.7925C9.33323 11.2735 10.2135 10.9404 10.0317 10.4595C9.77166 9.77293 8.87101 7.29868 8.70617 6.94862C8.6314 6.78718 8.35951 6.66992 8.09611 6.66992C7.87859 6.66992 7.66617 6.74979 7.57611 6.94862",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17_130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 5,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15925 7.70092L8.67415 9.3153H7.60016L8.15925 7.70092ZM7.58147 6.94471C7.35375 7.44602 6.52957 9.81661 6.25767 10.4454C6.06055 10.8991 6.91192 11.2696 7.10905 10.8158L7.29428 10.1684H8.98853C8.98853 10.1684 8.93075 10.1956 9.15506 10.7886C9.33689 11.2696 10.2172 10.9365 10.0353 10.4556C9.77533 9.76903 8.87467 7.29477 8.70984 6.94471C8.63506 6.78327 8.36317 6.66602 8.09977 6.66602C7.88225 6.66602 7.66983 6.74588 7.57977 6.94471",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2204 6.66602H6.06042V11.2713H10.2204V6.66602Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3571 7.09646C10.3571 7.90195 10.3622 10.4986 10.3622 10.4986C10.3622 10.4986 10.2874 11.0152 10.7309 11.0152C11.1745 11.0152 12.155 11.0101 12.59 11.0101C13.025 11.0101 13.0233 10.0839 12.5883 10.0839C12.1533 10.0839 11.358 10.0788 11.358 10.0788C11.358 10.0788 11.3614 7.67764 11.3597 7.09306C11.3597 6.81097 11.1082 6.66992 10.8584 6.66992C10.6086 6.66992 10.3554 6.81267 10.3571 7.09476",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17_130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 3,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.353 7.09255C10.353 7.89804 10.3581 10.4947 10.3581 10.4947C10.3581 10.4947 10.2834 11.0113 10.7269 11.0113C11.1704 11.0113 12.1509 11.0062 12.586 11.0062C13.021 11.0062 13.0193 10.08 12.5843 10.08C12.1492 10.08 11.354 10.0749 11.354 10.0749C11.354 10.0749 11.3574 7.67373 11.3557 7.08915C11.3557 6.80706 11.1041 6.66602 10.8543 6.66602C10.6045 6.66602 10.3513 6.80876 10.353 7.09085",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0204 6.66602H10.2827V11.0096H13.0204V6.66602Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1407 6.96952C13.1509 7.32298 13.1288 10.5178 13.1288 10.754C13.1288 11.1278 14.0804 11.1261 14.0804 10.754C14.0804 10.3206 14.0804 9.49645 14.0804 9.49645L14.3591 9.27213L15.5809 10.9375C15.8274 11.2638 16.604 10.6741 16.3575 10.3495L15.0609 8.64168C15.0609 8.64168 15.9412 7.69004 16.2879 7.34507C16.4901 7.14455 15.863 6.51239 15.6608 6.71461C15.4654 6.90834 14.0855 8.28991 14.0855 8.28991C14.0855 8.28991 14.0974 7.42324 14.0855 6.94402C14.0804 6.76219 13.8578 6.67383 13.6284 6.67383C13.3837 6.67383 13.1339 6.77409 13.139 6.96952",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17_130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 4,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1407 6.9617C13.1509 7.31517 13.1288 10.5099 13.1288 10.7462C13.1288 11.12 14.0804 11.1183 14.0804 10.7462C14.0804 10.3128 14.0804 9.48864 14.0804 9.48864L14.3591 9.26432L15.5809 10.9297C15.8274 11.256 16.604 10.6663 16.3575 10.3417L15.0609 8.63386C15.0609 8.63386 15.9412 7.68223 16.2879 7.33726C16.4901 7.13674 15.863 6.50458 15.6608 6.7068C15.4654 6.90053 14.0855 8.2821 14.0855 8.2821C14.0855 8.2821 14.0974 7.41543 14.0855 6.93621C14.0804 6.75438 13.8578 6.66602 13.6284 6.66602C13.3837 6.66602 13.1339 6.76628 13.139 6.9617",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.604 6.50977H13.1288V11.2611H16.604V6.50977Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9995,
    height: 16.5347,
    fill: "white",
    transform: "translate(1 1.73242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.c5d7b76d85081d44033872c139e9c618.svg";
export { ForwardRef as ReactComponent };